import { fixedNumber } from "@shared/lib/utils";
import { Account } from "@models/account";
import { DocumentItemAdd } from "@models/document-item";
import { DocumentSettings } from "@models/document-settings";
import { DocumentWorkAdd } from "@models/document-work";
import { DocumentPaymentForm } from "@models/document-payment";
import { Document } from "@models/document";



type DocumentForm = {
  getValues: (name: "to_pay") => number | undefined;
  setValue: (
    name:
      | "to_pay"
      | "receipt"
      | "balance"
      | "works_total"
      | "items_total"
      | "total"
      | "include_vat"
      | "not_include_vat"
      | "vat"
      | "discount"
      | "discount_percentage",
    value: number,
  ) => void;
};

export function calcWorksAndItems( documentForm: DocumentForm, works: DocumentWorkAdd[], items: DocumentItemAdd[], settings?: DocumentSettings, incomes?: Account[]): void {
  
  if (!settings || !incomes) {
    return;
  }

  if (settings.display_works === false && settings.display_items === false) {
    return;
  }

  const { totalPriceWorks, totalPriceWorksNoVat } = calcWorks(works, incomes, settings);
  const { totalPriceItems, totalPriceItemsNoVat } = calcItems(items, incomes, settings);

  documentForm.setValue("works_total", fixedNumber(totalPriceWorks + totalPriceWorksNoVat));
  documentForm.setValue("items_total", fixedNumber(totalPriceItems + totalPriceItemsNoVat));

  const totalWorksAndItemsWithVat = totalPriceWorks + totalPriceItems;
  const totalWorksAndItemsNoVat = totalPriceWorksNoVat + totalPriceItemsNoVat;
  const totalWorksAndItems = totalWorksAndItemsWithVat + totalWorksAndItemsNoVat;
  const { vat, to_pay, rounded } = calcVatAndFinalPay(
    totalPriceWorks,
    totalPriceItems,
    totalWorksAndItemsNoVat,
    settings,
  );

  documentForm.setValue("total", fixedNumber(totalWorksAndItems));
  documentForm.setValue("include_vat", fixedNumber(totalWorksAndItemsWithVat - rounded));
  documentForm.setValue("not_include_vat", fixedNumber(totalWorksAndItemsNoVat));
  documentForm.setValue("vat", fixedNumber(vat, 3));
  documentForm.setValue("discount", fixedNumber(rounded));
  documentForm.setValue("discount_percentage", fixedNumber((rounded / totalWorksAndItems) * 100 || 0, 3));
  documentForm.setValue("to_pay", fixedNumber(to_pay));

  if (settings.type === "חשבונית מס") {
    documentForm.setValue("balance", fixedNumber(to_pay));
  }
}

export function calcWorks(works: DocumentWorkAdd[], incomes: Account[], settings: DocumentSettings) {
  let totalPriceWorks = 0;
  let totalPriceWorksNoVat = 0;

  if (settings.display_works) {
    works.forEach((row) => {
      const incomeCard = incomes.find((income) => income.card_number === row.income_card);
      if (incomeCard && incomeCard.vat_include === false) {
        totalPriceWorksNoVat += row.total;
      } else {
        totalPriceWorks += row.total;
      }
    });
  }

  return { totalPriceWorks, totalPriceWorksNoVat };
}

export function calcItems(items: DocumentItemAdd[], incomes: Account[], settings: DocumentSettings) {
  let totalPriceItems = 0;
  let totalPriceItemsNoVat = 0;

  if (settings.display_items) {
    items.forEach((row) => {
      const incomeCard = incomes.find((income) => income.card_number === row.income_card);
      if (incomeCard && incomeCard.vat_include === false) {
        totalPriceItemsNoVat += row.total;
      } else {
        totalPriceItems += row.total;
      }
    });
  }

  return { totalPriceItems, totalPriceItemsNoVat };
}

export function calcVatAndFinalPay(totalPriceWorks: number, totalPriceItems: number, totalWorksAndItemsNoVat: number, settings: DocumentSettings) {
  
  const totalWorksAndItemsWithVat = totalPriceWorks + totalPriceItems;
  const totalWorksAndItems = totalWorksAndItemsNoVat + totalWorksAndItemsWithVat;

  let vat;
  let to_pay = 0;
  let rounded = 0;

  if (settings?.circle) {
    const vatRate = 17 / 100;
    vat = totalWorksAndItemsWithVat * vatRate;
    to_pay = Math.round(totalWorksAndItems + vat);
    const desired_total_With_Vat = (to_pay - totalWorksAndItemsNoVat) / (1 + vatRate);
    rounded = totalWorksAndItems - desired_total_With_Vat - totalWorksAndItemsNoVat;
    vat = desired_total_With_Vat * 0.17;
  } else {
    vat = (totalPriceWorks + totalPriceItems) * 0.17;
    to_pay = vat + totalWorksAndItems;
  }

  return { vat, to_pay, rounded };
}

export function calcKabala( documentForm: DocumentForm, payments: DocumentPaymentForm[], settings?: DocumentSettings, documentsToClose?: Document[]): void {
  
  if (!settings) {
    return;
  }

  let totalPricePayments = 0;
  payments.forEach((row) => {
    totalPricePayments += row.total;
  });

  if (settings.type === "חשבונית מס קבלה") {
    const heshbonitPrice = documentForm.getValues("to_pay");
    if (heshbonitPrice) {
      documentForm.setValue("balance", fixedNumber(heshbonitPrice - totalPricePayments));
    }
    documentForm.setValue("receipt", totalPricePayments);
  }

  if (documentsToClose) {
    let to_pay = 0;
    documentsToClose.forEach((document) => {
      to_pay += document.balance || 0;
    });

    documentForm.setValue("to_pay", fixedNumber(to_pay));
    documentForm.setValue("receipt", totalPricePayments);
    documentForm.setValue("balance", fixedNumber(to_pay - totalPricePayments));
  }
}